import { useEffect } from 'react';
import { useCrewQuote } from '../crew/CrewQuotePrompt';

/**
 * Owner 18:07: after a crew change the event's quote question (once) and the „Obsada różni się od kosztorysu” notice
 * (also after „Obsadź…” of several cells in the grid — review M1).
 */
export function QuoteAfterFill({ eventId }: { eventId: string }) {
  const quote = useCrewQuote(eventId);
  useEffect(() => {
    void quote.ask();
    // once per fill
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {quote.notice}
      {quote.dialog}
    </>
  );
}
